export const SmartPoolChainIds = [137, 56, 10, 42161, 1088, 8453, 43114, 1101, 2222, 59144, 534352, 250, 81457, 30];
export function isSmartPoolChainId(value) { return SmartPoolChainIds.includes(value); }
